import { render, staticRenderFns } from "./TeamIcon.vue?vue&type=template&id=8d0c848a&"
import script from "./TeamIcon.vue?vue&type=script&lang=ts&"
export * from "./TeamIcon.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports